import React from "react";
import { graphql } from "gatsby";
import { CookieBanner } from "./CookieBanner";

interface Props {}

const CookieBannerContainer: React.FC<Props> = () => {
  return <CookieBanner></CookieBanner>;
};

export default CookieBannerContainer;

/* Verify kontent_item_component___ name

export const fragmentCookieBannerContainer = graphql`
    fragment CookieBannerContainer on kontent_item_cookie_banner {
      system {
        id
        codename
      }
      internal {
        type
        contentDigest
      }

    }
    `;
*/
